<template>
  <v-navigation-drawer
    app
    clipped
    v-model="DRAWER_STATE"
    :mini-variant="!DRAWER_STATE"
    :width="sidebarWidth"
    :permanent="$vuetify.breakpoint.mdAndUp"
    :temporary="$vuetify.breakpoint.smAndDown"
    :mini-variant-width="sidebarMinWidth"
    :class="{ 'drawer-mini': !DRAWER_STATE }"
  >
    <v-list>
      <v-row align="center">
        <v-col cols="12">
          <span
            style="padding-left: 32px"
            class="text-body-1 subheader d-flex flex-column"
          >
            <div class="mb-1">ID Anda</div>
            <div class="black--text font-weight-bold">
              {{ this.$store.state.profile.personName }}
            </div>
          </span>
        </v-col>
      </v-row>
      <template v-for="(item, i) in items">
        <v-row
          v-if="
            item.heading &&
              (typeof item.hasAccess == 'undefined' || item.hasAccess)
          "
          :key="item.heading"
          align="center"
        >
          <v-col cols="6">
            <span
              style="padding-left: 32px"
              class="text-body-1 subheader"
              :class="item.heading && DRAWER_STATE ? 'show ' : 'hide'"
            >
              {{ item.heading }}
            </span>
          </v-col>
          <v-col cols="6" class="text-center"> </v-col>
        </v-row>
        <v-divider
          v-else-if="item.divider"
          :key="i"
          dark
          class="my-4"
        ></v-divider>
        <!-- <v-list-group
          color="primary"
          v-else-if="
            item.subMenus &&
              DRAWER_STATE &&
              (typeof item.subMenus.hasAccess == 'undefined' ||
                item.subMenus.hasAccess) &&
              item.hasAccess
          "
          :key="item.title"
          v-model="item.model"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>
                {{ item.title }}
              </v-list-item-title>
            </v-list-item-content>
          </template>
          <template v-for="(child, i) in item.subMenus">
            <v-list-item
              v-if="typeof child.hasAccess == 'undefined' || child.hasAccess"
              :key="i"
              :to="child.link === '#' ? null : child.link"
              link
            >
              <v-list-item-content>
                <v-list-item-title link>
                  {{ child.title }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list-group> -->

        <v-list-group
          color="primary"
          v-else-if="
            item.subMenus
          "
          :key="item.title"
          v-model="item.model"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>
                <v-icon class="mr-1">{{ item.icon }}</v-icon>
                {{ item.title }}
              </v-list-item-title>
            </v-list-item-content>
          </template>
          <!-- <template v-for="(child, i) in item.subMenus"> -->
            <v-list-item
              v-for="(child, i) in item.subMenus"
              :key="i"
              @click="showDialogConfirm(child.distributorCode)"
              :disabled="child.distributorCode == distType"
            >
              <v-list-item-content>
                <v-list-item-title :class="{'text-choosed': child.distributorCode == distType }">
                  {{ child.distributorCode }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          <!-- </template> -->
        </v-list-group>
        
        <v-list-item
          color="primary"
          v-else-if="typeof item.hasAccess == 'undefined' || item.hasAccess"
          :key="item.text"
          :to="item.link === '#' ? null : item.link"
          link
        >
          <v-list-item-content>
            <v-list-item-title link>
                <v-icon class="mr-1">{{ item.icon }}</v-icon>
              {{ item.title }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

      </template>
      <v-row class="mt-10">
        <v-col cols="12">
          <v-dialog v-model="dialog" persistent max-width="300">
            <template v-slot:activator="{ on, attrs }">
              <v-btn block text color="primary" v-bind="attrs" v-on="on"
                >Sign Out
              </v-btn>
            </template>
            <div class="signOutDialog">
                <p class="text-center font-weight-medium text-h6">Apa kamu yakin ingin keluar dari website ?</p>
              <v-btn @click="dialog = false" class="btnCancel" style="background: black;">
                Tidak
              </v-btn>
              <v-btn @click="logOut" class="btnLogout">
                Keluar
              </v-btn>
              </div>
          </v-dialog>
        </v-col>
      </v-row>
    </v-list>
    <v-row>
      <v-col cols="12">
        <v-dialog v-model="dialogChangeDistributor" persistent max-width="350px">
          <v-card class="pa-3">
            <v-card-title class="text-center">
              Ganti Distributor ?
            </v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="dialogChangeDistributor = false; typeDistributor = ''" >
                Tidak
              </v-btn>
              <v-btn @click="changeDistributor(typeDistributor)" color="primary">
                Ganti
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
      <v-col cols="12">
        <v-dialog v-model="dialogMsg" persistent max-width="350px">
          <v-card class="pa-3">
            <v-card-title class="text-center">
              {{ this.objMsg.title }}
            </v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="dialogMsg = false; objMsg = {title: '', btn: ''}" >
                {{ this.objMsg.btn }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
  </v-navigation-drawer>
</template>

<script>
import config from "../../config";
import { mapActions, mapState } from "vuex";

export default {
  name: "Sidebar",
  props: {
    source: String,
  },
  data() {
    return {
      dialogChangeDistributor: false,
      dialog: false,
      config,
      items: [
        { title: "Beranda", link: "/dashboard", icon:"mdi-home-outline" },
        // {
        //   title: "Riwayat Pembayaran",
        //   link: "/premium-payment-history",
        //   hasAccess: true,
        //   icon: "mdi-home-outline"
        // },
        { title: "Transaksi", link: "/transactions/tab-OS_ALL_TRANS",icon:"mdi-credit-card" },
        { title: "Distributor",icon:"mdi-account-group",
          subMenus: this.$store.state.distTypeList
         },
        { title: "Akun", link: "/profile",icon:"mdi-account-circle-outline" },
        { title: "Notifikasi", link: "/notifications",icon:"mdi-bell-outline" },
        // {
        //   title: "Virtual Account",
        //   hasAccess: (this.hasFeature("REG_VA") || this.hasFeature("HIS_VA") || this.hasFeature("CASH_OUT")),
        //   subMenus: [
        //     {
        //       title: "Aktivasi VA",
        //       link: "/va-registration",
        //       hasAccess: this.hasFeature("REG_VA"),
        //     },
        //     {
        //       title: "Mutasi VA",
        //       link: "/va-history",
        //       hasAccess: this.hasFeature("HIS_VA"),
        //     },
        //     {
        //       title: "Tarik Dana",
        //       link: "/withdrawal",
        //       hasAccess: this.hasFeature("CASH_OUT"),
        //     },
        //   ],
        // },
        {
          title: "Keranjang",
          link: "/cart/new",
          hasAccess: true,
            // this.hasFeature("CART_DRAFT") || this.hasFeature("CART_NEW"),
          icon: "mdi-cart"
        },
        // {
        //   title: "Sales Kit",
        //   link: "/sales-kit",
        //   hasAccess: this.hasFeature("VIEW_SALES_KIT"),
        // },
        // {
        //   title: "Informasi Program",
        //   link: "/program-information",
        //   hasAccess: this.hasFeature("VIEW_PROGRAM"),
        // },
        // {
        //   title: "FAQ",
        //   link: "/help-center",
        //   hasAccess: this.hasFeature("VIEW_FAQ"),
        // },
        // {
        //   title: "Pengaturan",
        //   hasAccess: (this.hasFeature("CHANGE_PIN") || this.hasFeature("RESET_PIN") || this.hasFeature("CHANGE_PASS")),
        //   subMenus: [
        //     {
        //       title: "Ubah PIN",
        //       link: "/change-pin",
        //       hasAccess: this.hasFeature("CHANGE_PIN"),
        //     },
        //     {
        //       title: "Reset PIN",
        //       link: "/reset-pin-link",
        //       hasAccess: this.hasFeature("RESET_PIN"),
        //     },
        //     {
        //       title: "Ubah Password",
        //       link: "/change-pass",
        //       hasAccess: this.hasFeature("CHANGE_PASS"),
        //     },
        //     {
        //       title: "Detail Atasan",
        //       link: "/detail-atasan",
        //       hasAccess: this.hasFeature("DETAIL_ATASAN"),
        //     },
        //     {
        //       title: "Upline",
        //       link: "/upline",
        //       hasAccess: this.hasFeature("UPLINE"),
        //     },
        //   ],
        // },
        // {
        //   title: "Produk",
        //   link: "/products",
        //   hasAccess: this.hasFeature("VIEW_PRODUCT"),
        // },
        // {
        //   title: 'Akun',
        //   // icon: 'mdi-image-filter-none',
        //   link: '/profile',
        //   model: false,
        //   children: [
        //     { title: 'Aktivasi VA', link: '/va-registrasi' },
        //     { title: 'Ubah PIN', link: '/change-pin' },
        //     { title: 'Reset PIN', link: '/reset-pin' },
        //     { title: 'Ubah Kata Sandi', link: '/change-pass' },
        //     { title: 'Profil', link: '/profile' },
        //   ],
        // }
        // { title: 'Dashboard', icon: 'mdi-home', link: '/dashboard' },
        // { title: 'Typography', icon: 'mdi-format-size', link: '/typography' },
        // { title: 'Tables', icon: 'mdi-grid-large', link: '/tables' },
        // { title: 'Notifications', icon: 'mdi-bell-outline', link: '/notifications' },
        // {
        //   title: 'UI Elements',
        //   icon: 'mdi-image-filter-none',
        //   link: '/icons',
        //   model: false,
        //   children: [
        //     { title: 'Icons', icon: 'mdi-circle-small', link: '/icons'},
        //     { title: 'Charts', icon: 'mdi-circle-small', link: '/charts'},
        //     { title: 'Maps', icon: 'mdi-circle-small', link: '/maps'},
        //   ],
        // }
      ],
      sidebarWidth: 240,
      sidebarMinWidth: 0, //96
      typeDistributor: '',
      objMsg: {
        title: '',
        btn: ''
      },
      dialogMsg: false,
    };
  },
  computed: {
    ...mapState(["drawer","distTypeList","distType","profile"]),
    DRAWER_STATE: {
      get() {
        return this.drawer;
      },
      set(newValue) {
        if (newValue === this.drawer) return;
        this.TOGGLE_DRAWER();
      },
    },
  },
  methods: {
    ...mapActions(["TOGGLE_DRAWER","getOid"]),
    showDialogConfirm(type){
      this.typeDistributor = type;
      this.dialogChangeDistributor = true;
    },
    changeDistributor(type){
      this.getOid(this.profile.mobileNo)
      .then((response) => {
        if (response.data.status == 1) {
          this.$store.commit("setDistType", type);
          this.typeDistributor = '';
          window.location.reload()
        }else{
          this.dialogMsg.title = response.data.message;
          this.dialogMsg.btn = 'Tutup'
          this.dialogMsg = true;
        }
        console.log(response);
        console.log(type)
      })
      // this.$store.commit("setDistType", type);
      // window.location.reload()
      // this.typeDistributor = '';
    },
    logOut: function() {
      this.$store
        .dispatch("logout")
        .then((response) => {
          if (response) {
            let data = response.data;
            if (data.status == 0) {
              //handle jika message token expired, loloskan ke hal login
              if (this.$constant.ERR_EXPIRED_TOKEN_MSG === data.message) {
                this.$store.commit('logout');
                this.$router.push({ name: "home" });
              }else{
                const snackbarMsg = data.message;
                const snackbarColor = "red";
                this.$store.commit("setShowSnackbar", {
                  snackbarMsg,
                  snackbarColor,
                });
              }
              
            } else {
              const snackbarMsg = data.message;
              const snackbarColor = "green";
              this.$store.commit("setShowSnackbar", {
                snackbarMsg,
                snackbarColor,
              });

              this.$router.push({ name: "home" });
            }
          }
        })
        .catch((error) => {
          if (error.response) {
            let response = error.response;
            // let data = response.data;
            let hasToken = !!response.config.headers.Authorization;
            // console.log(response)
            switch (response.status) {
              case 403:
                if (hasToken) {
                  this.$store.commit("logout");
                  this.$store.commit("resetCart");
                  this.$router.push({ name: "home" });
                }
            }
          }
          // console.log(err.response);
          // let hasToken = !!err.response.config.headers.Authorization;
          // switch(err.response.status){
          //   case 403 : if (hasToken){
          //     this.$store.commit('logout')
          //     return this.$router.push('/')
          //   }
          // }
        });
    },
  },
  created() {
    // console.log('ada ga oid nya', this.$store.state.profile)
    // console.log(this.$router.resolve({ name: 'resetPinLink' }))
    // console.log('get feature di sidebar', Object.values(this.$store.state.features).length)
  },
};
</script>

<style src="./Sidebar.scss" lang="scss" />
